var render, staticRenderFns
import script from "./GreenPopupBuy.vue?vue&type=script&lang=js"
export * from "./GreenPopupBuy.vue?vue&type=script&lang=js"
import style0 from "./GreenPopupBuy.vue?vue&type=style&index=0&id=1d4905ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4905ee",
  null
  
)

export default component.exports